import React from "react";
import translate from "components/translations/translations.wrapper";
import { Button, ButtonType } from "components/common/Button.component";
import { ArrowLeftToLineIcon, ArrowRightToLineIcon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";


interface MinMaxGroupProps {
    translate: React.FC;
    isAttachmentPanelMaxWidth: boolean;
    isAttachmentPanelWidthDefault: boolean;
    maximizePanel: () => void;
    minimizePanel: () => void;
}

export const MinMaxGroup = ({
                                translate,
                                isAttachmentPanelMaxWidth,
                                isAttachmentPanelWidthDefault,
                                maximizePanel,
                                minimizePanel,
                            }: MinMaxGroupProps): React.ReactElement => {

    return <div className="min-max-btn-group w-25 bg-white d-flex flex-row justify-content-end gap-8">
        <Button type= {ButtonType.GHOST}
                onClick={isAttachmentPanelMaxWidth ? undefined : maximizePanel}
                disabled={isAttachmentPanelMaxWidth}
                iconOnly={true}
                title={translate("taskDetail.maximize")?.toString()}
                dataTestId={"__tst_maximize"}
                icon={<ArrowLeftToLineIcon size={ICON_SIZE.MEDIUM}/>}/>
        <Button type= {ButtonType.GHOST}
                onClick={isAttachmentPanelWidthDefault ? undefined : minimizePanel}
                disabled={isAttachmentPanelWidthDefault}
                iconOnly={true}
                title={translate("taskDetail.minimize")?.toString()}
                dataTestId={"__tst_minimize"}
                icon={<ArrowRightToLineIcon size={ICON_SIZE.MEDIUM}/>}/>
    </div>;


};

export default translate(MinMaxGroup);